<div class="loader" [ngClass]="{'loader--floating': floating}">
  <svg
    class="loader__svg"
    width="94"
    height="94"
    viewBox="0 0 94 94"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="loader__path"
      stroke="#1E1E1E"
      stroke-width="1"
      d="M76.9749 22.5837L50.8774 92.2903H40.7425L9.95777 14.2341C8.31085 10.0592 6.66397 6.64354 0.709717 2.46873V1.70966H44.7965V2.59521C39.4757 6.01096 37.3221 8.16161 37.3221 11.7039C37.3221 13.981 38.2089 16.7643 39.6024 20.686L56.1982 66.2294L72.5408 22.0777L72.6016 21.9184C73.5895 19.3297 74.4411 17.0981 74.4411 14.8666C74.4411 11.1978 72.1607 7.52907 64.0528 2.59521V1.70966H91.2904V2.59521C82.169 10.4388 80.2687 13.8545 76.9749 22.5837ZM82.0646 92.2903C88.0862 92.2903 92.9678 87.4088 92.9678 81.3871C92.9678 75.3654 88.0862 70.4838 82.0646 70.4838C76.0429 70.4838 71.1613 75.3654 71.1613 81.3871C71.1613 87.4088 76.0429 92.2903 82.0646 92.2903Z"
      fill="transparent"
    />
  </svg>
</div>
